import React from 'react';
import styled from 'styled-components';

import { Tooltip } from '@shared/Tooltip';
import { isMobile } from '../../../constants';
import Info from '../../../images/info.inline.svg';
import { LINKS_COLOR, NOTES_COLOR } from '../../../theme';
import { TextareaCounter } from '../../TextareaCounter';

const Container = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: ${NOTES_COLOR};
  margin-top: 8px;
`;

const Content = styled.div`
  display: flex;
  align-items: center;
`;

const InfoIcon = styled(Info)`
  width: 24px;
  height: 24px;
  display: block;
  fill: ${LINKS_COLOR};
`;

type TextareaHintsTypes = {
  value: string;
  minLength: number;
  content?: string;
};

const TextareaHints = ({ value, minLength, content }: TextareaHintsTypes) => (
  <Container>
    <TextareaCounter value={value} minLength={minLength} />
    <Content>
      En manque d&apos;inspiration
      <Tooltip
        position="bottom right"
        trigger={isMobile ? 'click' : 'hover'}
        content={content}
        width={200}
      >
        <InfoIcon />
      </Tooltip>
    </Content>
  </Container>
);

TextareaHints.defaultProps = {
  content: 'Parlez de la qualité de la pédagogie des moniteurs, les locaux, l\'accueil, les temps d\'attente, le prix etc',
};

export { TextareaHints };
